import styles from "./styles.module.css";
import { IconType as ReactIconsIconType } from "react-icons";
import modalState from "../../state-observables/modal/ModalState";

type IconType = string;

export enum StatusButtonStatus {
    OKAY = "okay",
    WARNING = "warning",
    DANGER = "danger",
    DEACTIVATED = "deactivated",
    LOADING = "loading",
}

type Subtitles = {
    okay: string;
    warning?: string;
    danger?: string;
    deactivated: string;
};

type Props = {
    title: string;
    subtitles: Subtitles;
    icons?: { [key in StatusButtonStatus]: IconType };
    icon?: ReactIconsIconType;
    status: StatusButtonStatus;
    isEducator?: boolean;
    modals?: Partial<{ [key in StatusButtonStatus]: JSX.Element }>;
    onClick?: () => void;
};

export default function StatusButton({ title, subtitles, icons, icon, status, isEducator, onClick, modals }: Props) {

    let Icon: IconType | ReactIconsIconType;
    if (icons) {
        Icon = icons[status];
    } else if (icon) {
        Icon = icon;
    } else {
        throw new Error("You must provide either an icons object or an icon prop");
    }

    let iconJSX;
    if (typeof Icon === "string") {
        iconJSX = <img src={Icon} alt="icon" />;
    } else {
        iconJSX = <Icon size={isEducator ? 40 : 30} />;
    }

    let subtitleStyle;
    if (status === StatusButtonStatus.OKAY) {
        subtitleStyle = styles.okay;
    } else if (status === StatusButtonStatus.WARNING) {
        subtitleStyle = styles.warning;
    } else if (status === StatusButtonStatus.DANGER) {
        subtitleStyle = styles.danger;
    } else if (status === StatusButtonStatus.LOADING) {
        subtitleStyle = styles.loading;
    } else {
        subtitleStyle = styles.deactivated;
    }

    let subtitle;
    if (status === StatusButtonStatus.OKAY) {
        subtitle = subtitles.okay;
    } else if (status === StatusButtonStatus.WARNING) {
        subtitle = subtitles.warning;
    } else if (status === StatusButtonStatus.DANGER) {
        subtitle = subtitles.danger;
    } else if (status === StatusButtonStatus.DEACTIVATED) {
        subtitle = subtitles.deactivated;
    } else if (status === StatusButtonStatus.LOADING) {
        subtitle = "Loading...";
    }

    const handleClick = () => {
        if (modals && modals[status]) {
            modalState.setModal(modals[status], title);
        }
        if (onClick) {
            onClick();
        }
    }

    return (
        <div data-tooltip-id="tooltip" data-tooltip-content={subtitle} className={styles.statusButtonContainer} style={{
            height: isEducator ? "80px" : "70px",
            width: isEducator ? "70px" : "62px",
            border: isEducator ? "5px solid var(--colour-secondary)" : "none",
            cursor: isEducator ? "pointer" : "default",
            background: isEducator ? "white" : "transparent"
        }} onClick={handleClick}>
            {isEducator && <div className={styles.statusButtonTitle}>{title}</div>}
            {iconJSX}
            <div className={[styles.statusButtonSubtitle, subtitleStyle].join(" ")}>
                {isEducator && subtitle}
            </div>
        </div>
    );
}